import { useTranslation } from 'react-i18next';
import { SectionGridItem } from 'src/common/components/SectionGrid/SectionGridItem';
import { LastActiveProfile } from 'src/rSimInventory/RSimApi/rSimApi';

type CustomerCommsPlan = string | null | undefined;

type CustomerCommsPlanDetailProps = {
  primarySimEntry: { customerCommsPlan?: CustomerCommsPlan } | null;
  secondarySimEntry: { customerCommsPlan?: CustomerCommsPlan } | null;
  lastActiveProfile: LastActiveProfile;
};

export const CustomerCommsPlanDetail = ({
  primarySimEntry,
  secondarySimEntry,
  lastActiveProfile,
}: CustomerCommsPlanDetailProps) => {
  const { t } = useTranslation();
  let lastActiveRsimProfile = null;
  if (lastActiveProfile === LastActiveProfile.Primary) {
    lastActiveRsimProfile = primarySimEntry;
  }

  if (lastActiveProfile === LastActiveProfile.Secondary) {
    lastActiveRsimProfile = secondarySimEntry;
  }

  return (
    <SectionGridItem
      value={lastActiveRsimProfile?.customerCommsPlan}
      label={t('simInventory.customerCommsPlan')}
      testId="customerCommsPlan"
    />
  );
};
